import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../_common/_service/authservice.service';
import { TokenStorageService } from '../../../_common/_service/token-storage.service';
import { CommonService } from "../../../_common/_service/user.service";
import { PaymentConfirmDialogComponent } from '../../popup/payment-confirm-dialog/payment-confirm-dialog.component';
import { AuthenticationService } from '../../../_common/_service/authentication.service';
import { ConfirmPasswordDialogComponent } from '../../popup/confirm-password-dialog/confirm-password-dialog.component';
import { EncrDecrService } from '../../../_common/_service/EncrDecrService.service';

@Component({
  selector: 'app-view-payment-request',
  templateUrl: './view-payment-request.component.html',
  styleUrls: ['./view-payment-request.component.scss']
})
export class ViewPaymentRequestComponent implements OnInit {
  userorderdetailList: any;
  stringJson: any;
  stringObject: any;
  submitted = false;
  countryCode: any;
  channelList: any;
  balance: any;
  ServiceName: any;
  cUser: any;
  finalAmount: any;
  commissionFee: any;
  commissionTotal: any;
  amt: any;
  data: any;
  commissionList: any;
  FlatChargesByCountry: any;
  recentReceiver: any;
  show = 2;

  maxDate = new Date();
  currentUser: any;
  token: any;
  OptionList: any;
  UsertBal: any;
  serviceCode: any;
  countryIsdcode: any;
  transactionList: any;
  pageNumber = 1;
  total_count = 0;
  pageSize = 10;
  pageSizeOptions = [5, 10];
  loadingspinner: boolean = false;

  constructor(private authService: AuthService, private router: Router,
    private route: ActivatedRoute, public dialog: MatDialog, private encrDecrService: EncrDecrService,
    private toastr: ToastrService, private tokenStorageService: TokenStorageService, private tokenService: AuthenticationService, private _service: CommonService) {
    this.countryIsdcode = localStorage.getItem('countryIsdcode');
    //AccountCode == channel selected code
    //channel == channel selected name

  }


  ngOnInit(): void {


    this.token = this.tokenStorageService.getToken();
     this.serviceCode = this.route.snapshot.queryParams.serviceCode;
    if (this.token) {
      this.currentUser = this.tokenStorageService.getUser();
      this.UsertBal = this.tokenStorageService.getUsertBal();
      // this.getchannelList();
      this.viewTransactionsRequest(this.pageNumber);

    }
    else {
      this._service.callMethodOfSecondComponent();
    }



  }

  Back() {

    this.router.navigate(['/Go-on']);
  }

  /**handle*/
  handle(event: any) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex + 1;
    this.viewTransactionsRequest(this.pageNumber);
  }
  viewTransactionsRequest(d: any) {
    
    
    this.balance = this.UsertBal;
    const body = {
      PageNo: d,
      // TransactionType: type
    }


    this.authService.viewTransactionsRequest(this.currentUser.serviceid).subscribe(response => {
    
      // if (response.apiStatus == true && response.apiData.length != 0 && response.apiData.transactionStatus != 2) {
      if (response.apiStatus == true && response.apiData.length != 0) {
        this.total_count = response.apiData.length;
        this.transactionList = response.apiData;
      }
      else {
        this.total_count = response.apiData.length;

        //this.toastr.error(response.apiMessage, 'Error');
      }
    }, (err: any) => {
    
      if (err.error instanceof Error) {
        this.toastr.error(err.error, 'Error');
      } else {
        this.toastr.error(err.error, 'Error');
      }
    }
    );

  }



  manageTransactionsRequest(ezipayRefid: any, IsAccept: any, encrpass: any) {
    
    this.loadingspinner = true; 
    if (IsAccept == 1) {
      const body = {
        ezipayRefid: ezipayRefid,
        accountCode: this.serviceCode,
        password: encrpass
      }

      if (ezipayRefid != null) {

        this.authService.makepaymentRequestaccept(body, this.currentUser.serviceid).subscribe(response => {
          ;
          this.loadingspinner = false; 
          if (response.apiStatus == true && response.apiData == null) {
            this.toastr.error(response.apiMessage, 'Error');
          }
          else if (response.apiStatus == true && response.apiData.transactionStatus == 2) {
            this.data = response.apiData;
            ////////console.log("data succ response -", this.data);
            this.openPaymentConfirmDialog(this.data);

            this.submitted = false;

            this.commissionFee = 0;
            this.commissionTotal = 0;
            this.tokenService.updateMessagetoken('token');

          }

          //else if (response.apiStatus == true && response.apiData.transactionStatus != 2) {
          //  this.submitted = false;

          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');

          //  this.toastr.error(response.apiMessage, 'Error');
          //}
          else {
            this.toastr.error(response.apiMessage, 'Error');
          }
        }
          , (err: any) => {
            this.loadingspinner = false; 
            if (err.error instanceof Error) {
              this.toastr.error(err.error, 'Error');
            } else {
              this.toastr.error(err.error, 'Error');
            }
          }
        );
      }
    }
    else if (IsAccept == 0) {
      ;
     // const body = {
       // ezipayRefid: ezipayRefid

      //}

      if (ezipayRefid != null) {

        this.authService.makepaymentRequestfail(ezipayRefid, this.currentUser.serviceid).subscribe(response => {
          ;
          this.loadingspinner = false; 
          if (response.apiStatus == true && response.apiData == null) {
            this.toastr.success(response.apiMessage, 'Success');
            window.location.reload();

          }
          //else if (response.apiStatus == true) {
          //  this.data = response.apiData;
          //  ////////console.log("data succ response -", this.data);
          //  //this.openPaymentConfirmDialog(this.data);
          //  this.toastr.error(response.apiMessage, 'Error');
          //  this.submitted = false;

          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');

          //}
          //else if (response.apiStatus == true && response.apiData.transactionStatus != 2) {
          //  this.submitted = false;

          //  this.commissionFee = 0;
          //  this.commissionTotal = 0;
          //  this.tokenService.updateMessagetoken('token');

          //  this.toastr.error(response.apiMessage, 'Error');
          //}
          else {
            this.toastr.error(response.apiMessage, 'Error');
          }
        }
          , (err: any) => {
            this.loadingspinner = false; 
            if (err.error instanceof Error) {
              this.toastr.error(err.error, 'Error');
            } else {
              this.toastr.error(err.error, 'Error');
            }
          }
        );
      }
    }

  }


  openPaymentConfirmDialog(data: any) {
    const dialogRef = this.dialog.open(PaymentConfirmDialogComponent, {
      width: '350px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      window.location.reload();
    });

  }


  openPasswordDialog(ezipayRefrenceid: any, paystatus: any) {
    
    this.submitted = true;
    if (ezipayRefrenceid != null) {
      const dialogRef = this.dialog.open(ConfirmPasswordDialogComponent, {
        width: '450px',
        data: null
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result !== undefined && result !== null && result) {

          const body = {
            password: result
          }


          this.authService.checkpasswordviewpayment(body).subscribe((response: { apiStatus: boolean; apiMessage: string | undefined; apiData: any; transactionStatus: any }) => {
            debugger;
            this.loadingspinner = false;
            debugger;
            if (response.apiStatus == true) {
              this.toastr.success(response.apiMessage, 'Success');
              ////////view pay or reject below after pass rigfht
              if (paystatus == 1) {
                var encrpass = this.encrDecrService.set(body);
                this.manageTransactionsRequest(ezipayRefrenceid, paystatus, encrpass);
              }
              else {
                this.manageTransactionsRequest(ezipayRefrenceid, paystatus, null);
              }
             
              
            }
            else {
              this.toastr.error(response.apiMessage, 'Error');
            }
          }, (err: any) => {
            this.loadingspinner = false;
            if (err.error instanceof Error) {

              this.toastr.error(err.error, 'Error');
            } else {

              this.toastr.error(err.error, 'Error');
            }
          }
          );
        }
      });

    }
  }

}
